export default __webpack_public_path__ + "static/Speedee_W_Rg-d9a10a170ccda384848ab2d950b5a2a1.woff";